/**
 * Plan entitlements, for the API.
 *
 * The rules themselves live in `@cart/shared-utils` so the admin can print
 * exactly what this enforces — the pricing cards, the settings dialog and every
 * "blank means the plan allowance" hint all read the same numbers rather than
 * restating them as literals beside a rule they cannot see.
 *
 * This file stays as the API's import path so nothing here has to change, and
 * so a reader who lands on it finds the pointer rather than a stale copy.
 */
export {
  PLAN_QUOTA_BYTES,
  PLAN_TIERS,
  STORAGE_GRACE_BYTES,
  UNVERIFIED_PAID_CAP_BYTES,
  canCreateStores,
  canUseByos,
  effectivePlanQuotaBytes,
  formatPlanQuota,
  hardBlockBytes,
  planQuotaBytes,
  resolvePlanTier,
} from '@cart/shared-utils';

export type { PlanTier } from '@cart/shared-utils';

import { UNVERIFIED_PAID_CAP_BYTES as PAID_CAP } from '@cart/shared-utils';

/** @deprecated Both paid tiers share one provisional cap; use the new name. */
export const UNVERIFIED_PREMIUM_CAP_BYTES = PAID_CAP;
